import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=15dcfb8c&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15dcfb8c')) {
      api.createRecord('15dcfb8c', component.options)
    } else {
      api.reload('15dcfb8c', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=15dcfb8c&", function () {
      api.rerender('15dcfb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4d195u9WS0g8j/JS/comp/ImgFallback2.vue"
export default component.exports